<template functional>
    <div class="bto-sb-event-odds-info-cell">
        <span v-if="props.match.hasLiveStream" class="bto-sb-event-livestream"><i class="bto-app-live-stream-o"></i></span>
        <favorite-component v-if="props.showFavorite" :match="props.match"/>
        <statistics-component v-if="props.showStatistics" :betRadarId="props.match.betRadarId" :feedProvider="props.match.feedProvider" :isAwayAtHome="props.match.awayAtHome" :isLive="props.match.isLiveMatch" :sportId="props.match.sportId" :tournamentName="props.match.tournamentName"/>
    </div>
</template>

<script>
  export default {
    name: 'MatchInfo',
    props: {
      match: {
        type: Object,
        required: true,
        default: () => {
        }
      },
      showFavorite: {
        type: Boolean,
        default: true,
      },
      showStatistics: {
        type: Boolean,
        default: true,
      },
    }
  };
</script>
